import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getCommunicationApiUrl } from '@/api/apis/communication';
import {
  PersonalizationSettings,
  PersonalizationChannelUpdateData,
  PersonalizationSettingsChannelType,
} from '@/api/apis/communication/personalization/personalization.types';

const getPersonalizationSettings = async () => {
  const res = await http.get<ApiResponseBody<PersonalizationSettings>>(getCommunicationApiUrl.personalization());
  return res.data.data;
};

const updatePersonalizationCategoryChannel = async (
  categoryName: string,
  channelType: PersonalizationSettingsChannelType,
  data: PersonalizationChannelUpdateData,
) => {
  const res = await http.put<ApiResponseBody<PersonalizationChannelUpdateData>>(
    getCommunicationApiUrl.togglePersonalizationCategoryChannel(categoryName, channelType),
    data,
  );
  return res.data.data;
};

const updatePersonalizationEventChannel = async (
  eventName: string,
  channelType: PersonalizationSettingsChannelType,
  data: PersonalizationChannelUpdateData,
) => {
  const res = await http.put<ApiResponseBody<PersonalizationChannelUpdateData>>(
    getCommunicationApiUrl.togglePersonalizationEventChannel(eventName, channelType),
    data,
  );
  return res.data.data;
};

export const personalizationFetcher = {
  getPersonalizationSettings,
  updatePersonalizationCategoryChannel,
  updatePersonalizationEventChannel,
};
